<template>
  <div>
    <b-container>
      <b-row>
        <b-col>
          <b-alert show><img src="../../../../assets/images/logo.svg" /> {{ appDescription }}</b-alert>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="1">
          <b-button variant="link" size="sm" @click="goBack()"><i class="fas fa-arrow-circle-left"></i> Go back</b-button>
        </b-col>
        <b-col>
          <b-list-group class="about-list">
            <b-list-group-item>
              <div class="version-label">api version:</div><div label="version-number"> &nbsp; {{ apiVersion }}</div>
            </b-list-group-item>
            <b-list-group-item>
              <div class="version-label">web version:</div><div label="version-number"> &nbsp; {{ webVersion }}</div>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import appInfo from '../../../../package.json'
import versionApi from '../../../api/diagnostics-api.js'

export default {
  components: {
    versionApi
  },
  data: function() {
    return {
      apiVersion: ''
    }
  },
  computed: {
    appName () {
      return appInfo.name
    },
    appDescription () {
      return appInfo.description
    },
    webVersion () {
      return appInfo.version
    }
  },
  created: function () {
    this.getApiVersion()
  },
  methods: {
    getApiVersion () {
      versionApi.getApiVersion().then((response) => {
        this.apiVersion = response.data
      })
    },
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push({name: 'home'})
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';

img {
  border-radius: 4px;
  width: $spacing-sm;
}

button {
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/about/index.vue